/** Traductions affichage facture intelligente (FR / AR) */
export const smartInvoiceDisplayFr = {
  addressNotSpecified: 'Adresse non spécifiée',
  phoneNotSpecified: 'Téléphone non spécifié',
  ownerLabel: 'Propriétaire :',
  invoiceTitle: 'FACTURE',
  invoiceNumberLabel: 'N° Facture :',
  dateLabel: 'Date :',
  typeLabel: 'Type :',
  typeOrder: 'Commande',
  typePurchase: 'Achat',
  typeConsolidated: 'Consolidée',
  typeNormal: 'Normale',
  supplierInfo: 'Informations Fournisseur',
  unknownSupplier: 'Fournisseur inconnu',
  nameLabel: 'Nom :',
  addressLabel: 'Adresse :',
  phoneLabel: 'Téléphone :',
  productsLabel: 'Produits',
  productCol: 'Produit',
  skuCol: 'SKU',
  quantityCol: 'Quantité',
  unitPriceCol: 'Prix Unitaire',
  totalCol: 'Total',
  noProducts: 'Aucun produit',
  subtotalLabel: 'Sous-total :',
  tvaLabel: 'TVA (18%) :',
  grandTotalLabel: 'Total TTC :',
  totalAmountLabel: 'Total :',
  paidAmountLabel: 'Payé :',
  remainingAmountLabel: 'Restant :',
  consolidatedIncludes: 'Factures incluses',
  consolidatedHint: 'Cliquez sur une ligne pour voir l\'historique des paiements',
  consolidatedColDate: 'Date',
  consolidatedColStatus: 'Statut',
  paymentHistory: 'Historique des paiements',
  noPayments: 'Aucun paiement enregistré',
  paymentFull: 'Paiement complet',
  paymentPartial: 'Paiement partiel',
  purchaseInvoiceGroup: 'Facture achat',
  invoiceTotalLine: 'Total facture',
  paymentInfo: 'Informations de Paiement',
  thankYou: 'Merci pour votre confiance',
  paid: 'Payé',
  partial: 'Partiellement payé',
  pending: 'En attente',
  productsUnit: 'produits',
  printBtn: 'Imprimer',
  downloadPdf: 'Télécharger PDF',
  close: 'Fermer'
};

export const smartInvoiceDisplayAr = {
  addressNotSpecified: 'العنوان غير محدد',
  phoneNotSpecified: 'الهاتف غير محدد',
  ownerLabel: 'المالك:',
  invoiceTitle: 'فاتورة',
  invoiceNumberLabel: 'رقم الفاتورة:',
  dateLabel: 'التاريخ:',
  typeLabel: 'النوع:',
  typeOrder: 'طلبات',
  typePurchase: 'مشتريات',
  typeConsolidated: 'موحدة',
  typeNormal: 'عادية',
  supplierInfo: 'معلومات المورد',
  unknownSupplier: 'مورد غير معروف',
  nameLabel: 'الاسم:',
  addressLabel: 'العنوان:',
  phoneLabel: 'الهاتف:',
  productsLabel: 'المنتجات',
  productCol: 'المنتج',
  skuCol: 'SKU',
  quantityCol: 'الكمية',
  unitPriceCol: 'السعر',
  totalCol: 'المجموع',
  noProducts: 'لا توجد منتجات',
  subtotalLabel: 'المجموع الفرعي:',
  tvaLabel: 'TVA (18%):',
  grandTotalLabel: 'المجموع الإجمالي:',
  totalAmountLabel: 'الإجمالي:',
  paidAmountLabel: 'المدفوع:',
  remainingAmountLabel: 'المتبقي:',
  consolidatedIncludes: 'الفواتير المدمجة',
  consolidatedHint: 'انقر على الصف لعرض سجل المدفوعات',
  consolidatedColDate: 'التاريخ',
  consolidatedColStatus: 'الحالة',
  paymentHistory: 'سجل المدفوعات',
  noPayments: 'لا توجد مدفوعات مسجلة',
  paymentFull: 'دفع كامل',
  paymentPartial: 'دفع جزئي',
  purchaseInvoiceGroup: 'فاتورة شراء',
  invoiceTotalLine: 'إجمالي الفاتورة',
  paymentInfo: 'معلومات الدفع',
  thankYou: 'شكراً لثقتكم',
  paid: 'تم الدفع',
  partial: 'مدفوع جزئياً',
  pending: 'قيد الانتظار',
  productsUnit: 'منتج',
  printBtn: 'طباعة',
  downloadPdf: 'تحميل PDF',
  close: 'إغلاق'
};
